/**
 * Rspack entry point for the ServiceOne shell app.
 *
 * A bare dynamic import is the ONLY content allowed here.
 * This async boundary lets the Module Federation runtime finish
 * negotiating all shared singleton packages (React, ReactDOM, …)
 * before any application code runs, preventing React error #299
 * and duplicate-instance crashes.
 */
// biome-ignore lint/suspicious/noFloatingPromises: intentional bare dynamic import to preserve the MF async boundary
import('./bootstrap');
